export default __webpack_public_path__ + "static/media/rasberries.f81911a5.jpg";